<template>
  <div
    v-if="isOpen"
    class="coupon-modal-backdrop"
    @click.self="closeModal"
  >
    <div class="dialog-content text-center p-0 overflow-hidden">
      <div class="banner-top d-flex align-items-center justify-content-center p-4">
        <div class="icon-pulse">
          <i class="fas fa-percent text-white"></i>
        </div>
      </div>

      <div class="p-4 pt-5">
        <h3 class="font-weight-bolder text-dark mb-3">
          {{ percent }}% OFF na 1ª campanha! 🎉
        </h3>

        <p class="text-secondary mb-3 px-2">
          Use o cupom abaixo na criação da sua primeira rifa e ganhe
          <strong>{{ percent }}% de desconto</strong> na taxa de publicação.
        </p>

        <div class="coupon-box mb-4" role="button" tabindex="0" @click="copyCode" @keyup.enter="copyCode">
          <span class="coupon-code">{{ code }}</span>
          <small class="d-block text-xs text-secondary mt-1">toque para copiar</small>
        </div>

        <div class="d-flex flex-column gap-2 mb-2">
          <button type="button" class="btn btn-primary-gradient mb-0" @click.stop="goCreate">
            Criar minha campanha
          </button>
          <button type="button" class="btn btn-outline-secondary mb-0" @click.stop="closeModal">
            Depois eu uso
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FirstCouponModal",
  props: {
    isOpen: { type: Boolean, required: true },
    code: { type: String, default: "RIFA50" },
    percent: { type: Number, default: 50 },
  },
  methods: {
    closeModal() {
      this.$emit("confirm");
    },
    goCreate() {
      this.$emit("create");
    },
    async copyCode() {
      try {
        await navigator.clipboard.writeText(this.code);
        this.$toast?.add?.({
          severity: "success",
          summary: "Cupom copiado",
          detail: this.code,
          life: 2000,
        });
      } catch (_) {
        /* ignore */
      }
    },
  },
};
</script>

<style scoped lang="scss">
.coupon-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 200000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.55);
  pointer-events: auto;
}

.dialog-content {
  position: relative;
  z-index: 200001;
  width: min(440px, 100%);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  pointer-events: auto;
}

.banner-top {
  background: linear-gradient(135deg, #7c3aed, #db2777);
  min-height: 96px;
}

.icon-pulse {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
}

.coupon-box {
  border: 2px dashed #c4b5fd;
  background: #f5f3ff;
  border-radius: 12px;
  padding: 14px;
  cursor: pointer;
}

.coupon-code {
  font-size: 1.6rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #6d28d9;
}

.btn-primary-gradient {
  background: linear-gradient(135deg, #7c3aed, #db2777);
  color: #fff;
  border: none;
  cursor: pointer;
  pointer-events: auto;
  position: relative;
  z-index: 1;
}

.btn-outline-secondary {
  cursor: pointer;
  pointer-events: auto;
  position: relative;
  z-index: 1;
}
</style>
